import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { connect } from 'react-redux';
import { getRequestcall } from '../../comman/util/getRequest';
import { SERVICES } from '../../constants/apiurl';
import { useNavigate } from 'react-router-dom';
import { maintainStoretype } from "../../home/redux/actions";
import { useTranslation } from 'react-i18next';
import { fetchHeaderContent } from '../../seoroute/redux/actions';

function SitemapPage(props) {
    const { t } = useTranslation();
    const pages = [
        {
            title: t("pages.Home"),
            link: "/"
        },
        {
            title: t("pages.header.offer"),
            link: "/offers"
        },
        {
            title: t("pages.header.login"),
            link: "/login"
        },
        {
            title: t("pages.header.signup"),
            link: "/signup"
        },
        {
            title: t("pages.header.become_partner"),
            link: "/partner"
        },
        {
            title: t("pages.mycart"),
            link: "/cart"
        },
        {
            title: t("pages.wishlist.stores"),
            link: "/stores"
        },
    ];

    const usefulLinks = [
        {
            title: t("pages.footer.aboutus"),
            link: "/pages/about-us"
        },
        {
            title: t("pages.footer.terms"),
            link: "/pages/terms-conditions"
        },
        {
            title: t("pages.footer.privacy"),
            link: "/pages/privacy-policy"
        },
        {
            title: t("pages.footer.faqs"),
            link: "/pages/faqs"
        },
        {
            title: t("pages.footer.return"),
            link: "/pages/return-policy" 
        },
        {
            title: t("pages.Shipping Policies"),
            link: "/pages/shipping-policy"
        }
    ]

    const [goods,setGoods] = useState([]);
    const [services,setSerivces] = useState([]);
    const navigate = useNavigate();

    // eslint-disable-next-line
    useEffect(() => {
        callOnloadData();
        // eslint-disable-next-line
    }, [props?.language]);
    
    const callOnloadData = async () => {
        props?.fetchHeaderContent(t("pages.meta.sitemap.title"),t("pages.meta.sitemap.description"), "");
        let getserviceurl = SERVICES + `?lang=${props?.language?.toLowerCase()}`;
        let getCategories = await getRequestcall(getserviceurl, "");
        if (getCategories?.status === 200) {
          let getData = await getCategories.json();
          let getGoods = getData?.data?.filter((item) => item?.type === "goods");
          let getService = getData?.data?.filter((item) => item?.type === "service");
          getGoods = getGoods?.map((item)=>{return{title:item?.title,link:item?.id}});
          getService = getService?.map((item)=>{return{title:item?.title,link:item?.id}});
          setGoods(getGoods);
          setSerivces(getService)
        }
    }

   const navigatePage = (item,type) => {
       var timestamp = new Date().getTime();
       if(type === "Services:") {
         props.maintainStoretype("service");
         navigate("/stores/"+item?.link, { state: { obj: timestamp } });
      } else if(type === "Categories:") {
         props.maintainStoretype("goods");
         navigate("/stores/"+item?.link, { state: { obj: timestamp } });
       }else{
         navigate(item?.link);
       }
    }

    const getPageslist = (data, title,type) => {
        return (
            <Card className="sitemap-card">
                <Card.Body>
                    <Card.Title>{title}</Card.Title>
                    <ul className="site-list m-0">
                        {data?.map((item) => (
                            <li><span onClick={()=>navigatePage(item,type)} className="site-link">{item?.title}</span></li>
                        ))}
                    </ul>
                </Card.Body>
            </Card>
        )
    }

    return (
        <section className='site-map'>
            <div className="container">
               {getPageslist(pages, t("pages.Pages"),"Pages:")}
                {getPageslist(goods, t("pages.footer.categories"),"Categories:")}
                {getPageslist(services, t("pages.Services"),"Services:")}
                {getPageslist(usefulLinks, t("pages.footer.links"), "Useful Links:")}
            </div>
        </section>
    )
}

const mapStateToProps = (state) => ({
    language: state?.languageState?.language,
  });

export default connect(mapStateToProps,{maintainStoretype,fetchHeaderContent})(SitemapPage)